export const SIGN_UP = 'SIGN_UP';
export const LOADING = 'LOADING';
export const ERROR = 'ERROR';
